import { AppConfig } from '@mavles/shared';

export const environment: AppConfig = {
  production: false,
  apiUrl: 'https://qa-mavlesserver.selvaminterlockbricks.com/public/api/'
};
